import error from './error';
import success from './success';

const actions = {
  async error({dispatch}, data = {}) {
    let {message = 'There was an error, please try again.', timeout = 5000} = data
    dispatch('popups/update',{
      type: 'update',
      icon: 'error',
      message,
      timeout
    }, {root: true})
  },

  async success({dispatch}, data = {}) {
    let {message = 'Success.', timeout = 4000} = data
    dispatch('popups/update',{
      type: 'update',
      icon: 'success',
      message,
      timeout,
    }, {root: true})
  },

  async progress({dispatch}, data = {}) {
    let {message = 'Processing, please wait.', callback} = data
    dispatch('popups/update',{
      type: 'processing',
      message,
      callback
    }, {root: true})
  },

  async confirm({dispatch}, data = {}) {
    let {message = '', buttons = [{
      name: 'Close',
      id: 'close',
      function: 'close'
    },], description = ''} = data
    dispatch('popups/update',{
      type: 'confirm',
      message,
      buttons,
      description,
      ...data
    }, {root: true})
  },
};

export default {
  namespaced: true,
  modules: {
    error, success
  },
  actions
};
